import { Trans } from '@lingui/macro'

import * as React from 'react'

import { useTheme } from '~theme/ThemeProvider'
import { TColorKey } from '~theme/typings'
import { getColorValue } from '~theme/utils'
import { Icon } from '~ui/components/icons/Icon'
import { IconCheckMark } from '~ui/components/icons/specific/IconCheckMark'
import { Grid, GridCentered } from '~ui/components/layout/Box'
import { H3 } from '~ui/components/typography/Heading/Heading'
import { Text } from '~ui/components/typography/Text/Text'
import { getHeaderFontSizeInPx, letterSpacingValues } from '~ui/styleGuide/fontStyles'

type TProps = NoChildren & {
  message: React.ReactNode
  screenBgColor: TColorKey
  minHeadingBreakpoint: number
  maxHeadingBreakpoint: number
}

const DIMENSIONS = `6rem`
const ICON_SIZE = `3.5rem`

/**
 * Static message presented to the user right after the order
 * was submitted successfully - to confirm that action.
 */
export const SubmitConfirmationMessage: React.FC<TProps> = ({
  message,
  screenBgColor,
  minHeadingBreakpoint,
  maxHeadingBreakpoint,
}) => {
  const theme = useTheme()
  const borderColor = getColorValue(theme)(screenBgColor)

  return (
    <GridCentered rowGap={`smallMedium`}>
      <GridCentered
        borderWidth={`4px`}
        borderColor={borderColor}
        radius={`round`}
        width={DIMENSIONS}
        height={DIMENSIONS}
        bgColor={`specialColors.success`}
      >
        <Icon icon={IconCheckMark} iconSize={ICON_SIZE} />
      </GridCentered>
      <Grid gap={`small`}>
        <H3
          letterSpacing={letterSpacingValues.tight}
          fontStyle={`bold`}
          textAlign={`center`}
          responsiveSize={{
            minSize: getHeaderFontSizeInPx(`l24`),
            maxSize: getHeaderFontSizeInPx(`l34`),
            minBreakpoint: minHeadingBreakpoint,
            maxBreakpoint: maxHeadingBreakpoint,
          }}
        >
          <Trans>Order sent!</Trans>
        </H3>
        <Text contrast={`low`} textAlign={`center`}>
          {message}
        </Text>
      </Grid>
    </GridCentered>
  )
}
